import React from 'react';
import { Box, Text, Button, VStack, Icon } from '@chakra-ui/react';
import { FiInbox } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const EmptyState = ({ 
  title = 'No data available', 
  message = 'There is no data to display at the moment.', 
  actionLink = null,
  actionText = 'Create New',
  bgColor = "white",
  textColor = "gray.800",
  buttonColor = "blue.500",
  borderColor = "gray.200"
}) => {
  return (
    <Box 
      p={8} 
      textAlign="center" 
      bg={bgColor}
      borderRadius="md" 
      shadow="sm"
      border="1px"
      borderColor={borderColor}
    >
      <VStack spacing={4}>
        <Icon as={FiInbox} boxSize={12} color={textColor === "white" ? "gray.300" : "gray.400"} />
        <Text fontWeight="bold" fontSize="xl" color={textColor}>{title}</Text>
        <Text color={textColor === "white" ? "gray.300" : "gray.600"}>{message}</Text>
        
        {actionLink && (
          <Button 
            as={Link} 
            to={actionLink} 
            bg={buttonColor}
            color="white"
            _hover={{
              bg: typeof buttonColor === 'string' && buttonColor.includes('rgba') 
                ? buttonColor.replace(/[\d.]+\)$/, '0.6)') 
                : 'blue.600'
            }}
            size="md"
          >
            {actionText}
          </Button>
        )}
      </VStack>
    </Box>
  );
};

export default EmptyState; 